module.exports = __webpack_public_path__ + "img/c1.fddabdf8.png";